import { customerConfig } from '../customerConfig';

const allLanguages = {
    en: { id: 'en', locale: 'en', name: 'English' },
    de: { id: 'de', locale: 'de', name: 'German' },
    sv: { id: 'sv', locale: 'sv', name: 'Swedish' },
};

export const languages = customerConfig.supportedLanguages.map(lang => allLanguages[lang]).filter(Boolean);

export const locales = customerConfig.supportedLanguages;